import React, { useEffect, useMemo, useRef, useState } from 'react';

/**
 * Deterministic vertical arrow animation:
 * - one arrow per row
 * - fixed speed for all
 * - sequential delay per arrow (i * delayStepMs)
 * - pauses after durationSeconds
 */
export const ArrowGuide = ({
  count = 8,                 // number of rows (one arrow per row)
  durationSeconds = 4,       // total run time before pausing
  direction = 'mixed',       // 'up' | 'down' | 'mixed'
  color = '#08c',            // single color for all arrows
  size = 200,                 // arrow SVG size in px
  gap = 8,                   // vertical gap between rows (px)
  className,
  height = 1000,
}) => {

  const is_up = direction === 'up'
  const arrow_number = Math.max( 1, Math.round(height / size) );
  const arrows = [];
  for  ( let i = 0; i < arrow_number; i++ ) {
    arrows.push(i);
  }
  return (
    <div
      className={className}
      style={{
        position: 'absolute',
        left: '40%',
        top: 0,
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'stretch',
        zIndex: 29,
      }}
      aria-label="Animated vertical arrows"
    >
      {/* Keyframes + utility styles */}
      <style>{`
        @keyframes arrow-guide {
          0% {
            opacity: 0.2;
            transform:  translateY(40px) scale(1);
          }
          30% {
            opacity: 1;
          }
          100% {
            opacity: 0;
            transform:  translateY(-20px) scale(1);
          }
        }
        .arrow-guide-item {
          position    : absolute;
          color       :rgb(8, 134, 188);
          opacity     : 0.6;
          text-shadow : 4px 10px 5px rgba(1, 23, 48, 0.3);
          transition  : transform 0.3s ease;
          line-height : 1;
        }
        .arrow-guide-item.reverse {
          animation-direction: reverse;
        }
      `}</style>
      
      {arrows.map((a,index) => {
        const classNames = ['arrow-guide-item', is_up ?'':'reverse'].join(' ');
        return (
          <div
            className={classNames}
            style={{
              top: `${(height / arrow_number ) * index}px`,
              animationDelay: `${(is_up ? (arrow_number-index) : index )* 150}ms`,
            }}
          >
            <ArrowSVG color={color} size={size} direction={direction} />
          </div>
        );
      })}
    </div>
  );
};

const ArrowSVG = ({ color, size, direction }) => {
  const rotation = direction === 'up' ? 0 : 180;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      role="img"
      aria-label={`Arrow ${direction}`}
      style={{ transform: `rotate(${rotation}deg)` }}
    >
      {/* stem */}
      <rect x="11" y="5" width="2" height="12" fill={color} rx="1" />
      {/* head */}
      <polygon points="12,3 7,10 17,10" fill={color} />
    </svg>
  );
};